(function () {
	'use strict';

	angular.module('app.leanProjects')
		.service('projectTaskGroupService', projectTaskGroupService);

	projectTaskGroupService.$inject = ['$rootScope', '$http', '$filter', '$translate', 'URLS'];

	function projectTaskGroupService($rootScope, $http, $filter, $translate, URLS) {
		return {
			getTaskGroups: getTaskGroups
		};

		function getTaskGroups(projNdx, leanDirFactoryNdx) {
			var url = URLS.host + '2/factndx/' + leanDirFactoryNdx + '/projectId/' + projNdx + '/ProjectTaskGroup';
			return $http.get(url)
				.then(getTaskGroupsListComplete)
				.catch(getTaskGroupsListFailed);

			function getTaskGroupsListComplete(response) {
				return response.data || [];
			}

			function getTaskGroupsListFailed(error) {
				return [];
			}
		}
	}
})();
